/*
  Donate modal: open/close, focus trap, amount selection, custom amount,
  tab switching (one-time / subscription) with slide animation,
  and redirect to Monobank jar URL on submit.

  Subscription uses: POST cart/add.js {id, selling_plan}, then /checkout
  Plan IDs and variant IDs are read from data-sub-plans / data-sub-variants
  attributes on the modal element, set from Shopify theme settings.
*/
(function () {
  'use strict';

  var FOCUSABLE = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  var TAB_ORDER = { 'one-time': 0, 'subscription': 1 };
  var DONOR_STORAGE_KEY = 'galas:donor';

  var modalEl = null;
  var panelEl = null;
  var panelsAreaEl = null;
  var formEl = null;
  var titleEl = null;
  var impactTitleEl = null;
  var impactBodyEl = null;
  var chipsContainer = null;
  var customInputEl = null;
  var nameInputEl = null;
  var emailInputEl = null;
  var submitEl = null;
  var submitLabelEl = null;
  var errorEl = null;

  var subChipsEl = null;
  var subCustomInputEl = null;

  var subPlans = {};
  var subVariants = {};

  var defaults = {
    jarUrl: '',
    currency: '₴',
    defaultAmount: '500'
  };

  // Zloty branch of the one-time tab. Empty variant = not configured, in which
  // case the method switch is absent and everything behaves as before.
  var pln = {
    currency: 'zł',
    amounts: [],
    defaultAmount: '50',
    variant: '',
    min: 10
  };

  var sheets = { endpoint: '', token: '' };

  var state = {
    open: false,
    lastOpener: null,
    method: 'uah',
    amount: null,
    isOther: false,
    jarUrl: '',
    impactTitleDefault: '',
    impactBodyDefault: '',
    titleDefault: '',
    titleOpen: '',
    subAmount: null,
    subIsOther: false,
    currentTab: 'one-time'
  };

  function init() {
    modalEl = document.querySelector('[data-donate-modal]');
    if (!modalEl) return;

    panelEl = modalEl.querySelector('[data-donate-modal-panel]');
    panelsAreaEl = modalEl.querySelector('.donate-modal__panels-area');
    formEl = modalEl.querySelector('[data-donate-modal-form]');
    titleEl = modalEl.querySelector('[data-donate-modal-title]');
    impactTitleEl = modalEl.querySelector('[data-donate-impact-title]');
    impactBodyEl = modalEl.querySelector('[data-donate-impact-body]');
    chipsContainer = modalEl.querySelector('.donate-modal__chips');
    customInputEl = modalEl.querySelector('[data-donate-custom-input]');
    nameInputEl = modalEl.querySelector('[data-donate-name]');
    emailInputEl = modalEl.querySelector('[data-donate-email]');
    submitEl = modalEl.querySelector('[data-donate-submit]');
    submitLabelEl = modalEl.querySelector('[data-donate-submit-label]');
    errorEl = modalEl.querySelector('[data-donate-error]');

    subChipsEl = modalEl.querySelector('[data-donate-sub-chips]');
    subCustomInputEl = modalEl.querySelector('[data-donate-sub-custom-input]');

    defaults.jarUrl = modalEl.getAttribute('data-donate-jar-url') || '';
    defaults.currency = modalEl.getAttribute('data-donate-currency') || '₴';
    defaults.defaultAmount = modalEl.getAttribute('data-donate-default-amount') || '500';

    sheets.endpoint = modalEl.getAttribute('data-donate-sheets-endpoint') || '';
    sheets.token = modalEl.getAttribute('data-donate-sheets-token') || '';

    pln.currency = modalEl.getAttribute('data-donate-pln-currency') || 'zł';
    pln.amounts = (modalEl.getAttribute('data-donate-pln-amounts') || '')
      .split(',')
      .map(function (v) { return v.trim(); })
      .filter(Boolean);
    pln.defaultAmount = modalEl.getAttribute('data-donate-pln-default') || '50';
    pln.variant = (modalEl.getAttribute('data-donate-pln-variant') || '').trim();
    pln.min = parseInt(modalEl.getAttribute('data-donate-pln-min') || '10', 10) || 10;

    try { subPlans = JSON.parse(modalEl.getAttribute('data-sub-plans') || '{}'); } catch (_) { subPlans = {}; }
    try { subVariants = JSON.parse(modalEl.getAttribute('data-sub-variants') || '{}'); } catch (_) { subVariants = {}; }

    // Snapshot the server-rendered hryvnia chips: switching to zloty rebuilds
    // the list in place, so without this the way back would be lost.
    defaults.amountsList = chipsContainer
      ? Array.prototype.map
          .call(
            chipsContainer.querySelectorAll('[data-donate-amount]:not([data-donate-amount="other"])'),
            function (el) { return el.getAttribute('data-donate-amount'); }
          )
          .filter(Boolean)
      : [];

    state.jarUrl = defaults.jarUrl;
    state.titleDefault = titleEl ? titleEl.textContent.trim() : '';
    state.impactTitleDefault = impactTitleEl ? impactTitleEl.textContent.trim() : '';
    state.impactBodyDefault = impactBodyEl ? impactBodyEl.textContent.trim() : '';

    setupEvents();
    setActiveChipByValue(defaults.defaultAmount);
    updateSubmitLabel();
    reopenFromUrl();
  }

  /* Reopen the modal after a login round-trip (?donate_modal=<tab>) */
  function reopenFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var tab = params.get('donate_modal');
    if (!tab || !(tab in TAB_ORDER)) return;

    params.delete('donate_modal');
    var qs = params.toString();
    var cleanUrl = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    window.history.replaceState(null, '', cleanUrl);

    open(null, tab);
  }

  function setupEvents() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-donate-trigger]');
      if (trigger) {
        event.preventDefault();
        openFromTrigger(trigger);
      }
    });

    modalEl.querySelectorAll('[data-donate-modal-close]').forEach(function (el) {
      el.addEventListener('click', function (event) {
        event.preventDefault();
        close();
      });
    });

    if (chipsContainer) {
      chipsContainer.addEventListener('click', function (event) {
        var chip = event.target.closest('[data-donate-amount]');
        if (!chip) return;
        event.preventDefault();
        selectChip(chip);
      });
    }

    if (customInputEl) {
      customInputEl.addEventListener('focus', function () {
        var chip = customInputEl.closest('[data-donate-amount="other"]');
        if (chip) {
          state.isOther = true;
          activateChipElement(chip);
          state.amount = parseAmount(customInputEl.value);
          updateSubmitLabel();
        }
      });
      customInputEl.addEventListener('input', function () {
        clampCustomInput();
        state.amount = parseAmount(customInputEl.value);
        updateSubmitLabel();
        clearError();
      });
      // Blocks "." "," "e" before they ever reach the field in the zloty mode.
      customInputEl.addEventListener('keydown', function (event) {
        if (state.method !== 'pln') return;
        if (['.', ',', 'e', 'E', '+', '-'].indexOf(event.key) !== -1) event.preventDefault();
      });
    }

    modalEl.querySelectorAll('[data-donate-method]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        setMethod(btn.getAttribute('data-donate-method'));
      });
    });

    var tabs = modalEl.querySelectorAll('[data-donate-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        switchTab(tab.getAttribute('data-donate-tab'));
      });
    });

    if (formEl) {
      formEl.addEventListener('submit', onSubmit);
    }

    var freqInputs = modalEl.querySelectorAll('[data-donate-freq-input]');
    freqInputs.forEach(function (input) {
      input.addEventListener('change', updateSubCta);
    });

    if (subChipsEl) {
      subChipsEl.addEventListener('click', function (event) {
        var chip = event.target.closest('[data-donate-sub-amount]');
        if (!chip) return;
        event.preventDefault();
        selectSubChip(chip);
      });
    }

    if (subCustomInputEl) {
      subCustomInputEl.addEventListener('focus', function () {
        var chip = subCustomInputEl.closest('[data-donate-sub-amount="other"]');
        if (chip) {
          state.subIsOther = true;
          activateSubChip(chip);
          state.subAmount = parseAmount(subCustomInputEl.value);
          updateSubCta();
        }
      });
      subCustomInputEl.addEventListener('input', function () {
        state.subAmount = parseAmount(subCustomInputEl.value);
        updateSubCta();
        clearSubError();
      });
    }

    var subscribeBtn = modalEl.querySelector('[data-donate-subscribe]');
    if (subscribeBtn) {
      subscribeBtn.addEventListener('click', onSubscribeClick);
    }
  }

  function openFromTrigger(trigger) {
    var titleOverride = trigger.getAttribute('data-donate-title');
    var impactTitleOverride = trigger.getAttribute('data-donate-impact-title');
    var impactBodyOverride = trigger.getAttribute('data-donate-impact-body');
    var jarOverride = trigger.getAttribute('data-donate-jar-url');
    var tabOverride = trigger.getAttribute('data-donate-open-tab');

    // Kept apart from the element: the ambassador tab swaps the heading for its
    // own, and switching back has to restore whatever this trigger asked for.
    state.titleOpen = titleOverride || state.titleDefault;
    if (titleEl) titleEl.textContent = state.titleOpen;
    if (impactTitleEl) impactTitleEl.textContent = impactTitleOverride || state.impactTitleDefault;
    if (impactBodyEl) impactBodyEl.textContent = impactBodyOverride || state.impactBodyDefault;
    state.jarUrl = jarOverride && jarOverride !== '#donate' ? jarOverride : defaults.jarUrl;

    open(trigger, tabOverride || 'one-time');
  }

  function open(opener, initialTab) {
    if (state.open) return;
    state.open = true;
    state.lastOpener = opener || null;

    state.currentTab = initialTab || 'one-time';
    switchTab(state.currentTab, true);
    setActiveChipByValue(defaults.defaultAmount);
    clearError();
    if (customInputEl) customInputEl.value = '';
    if (subCustomInputEl) subCustomInputEl.value = '';

    // Guests: prefill saved details from a previous donation
    var donor = loadDonor();
    if (nameInputEl) nameInputEl.value = donor.name || '';
    if (emailInputEl) emailInputEl.value = donor.email || '';

    modalEl.hidden = false;
    requestAnimationFrame(function () {
      modalEl.classList.add('is-open');
      modalEl.setAttribute('aria-hidden', 'false');
    });

    document.documentElement.classList.add('is-donate-modal-open');
    document.body.classList.add('is-donate-modal-open');

    // The sheet itself, not its first control: a ring on «×» the moment the
    // modal opens reads as a pre-selected close. Tab goes on from here.
    var initial = panelEl;
    if (initial && typeof initial.focus === 'function') {
      initial.focus({ preventScroll: true });
    }

    document.addEventListener('keydown', onKeydown, true);
  }

  function close() {
    if (!state.open) return;
    state.open = false;

    modalEl.classList.remove('is-open');
    modalEl.setAttribute('aria-hidden', 'true');

    document.documentElement.classList.remove('is-donate-modal-open');
    document.body.classList.remove('is-donate-modal-open');

    document.removeEventListener('keydown', onKeydown, true);

    var styles = window.getComputedStyle(panelEl);
    var duration = parseDuration(styles.transitionDuration);
    var hide = function () {
      if (!state.open) modalEl.hidden = true;
    };
    if (duration > 0) {
      setTimeout(hide, duration);
    } else {
      hide();
    }

    if (state.lastOpener && typeof state.lastOpener.focus === 'function') {
      state.lastOpener.focus({ preventScroll: true });
    }
    state.lastOpener = null;
  }

  function onKeydown(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      event.preventDefault();
      close();
      return;
    }

    if (event.key === 'Tab') {
      var focusable = getFocusable();
      if (!focusable.length) {
        event.preventDefault();
        panelEl.focus({ preventScroll: true });
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var active = document.activeElement;

      if (event.shiftKey) {
        if (active === first || active === panelEl || !panelEl.contains(active)) {
          event.preventDefault();
          last.focus({ preventScroll: true });
        }
      } else if (active === last) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    }
  }

  function getFocusable() {
    var nodes = panelEl.querySelectorAll(FOCUSABLE);
    return Array.prototype.filter.call(nodes, function (el) {
      return !el.hasAttribute('disabled') && el.offsetParent !== null;
    });
  }

  function selectChip(chip) {
    var value = chip.getAttribute('data-donate-amount');
    if (value === 'other') {
      state.isOther = true;
      state.amount = parseAmount(customInputEl ? customInputEl.value : '');
      activateChipElement(chip);
      if (customInputEl) customInputEl.focus({ preventScroll: true });
    } else {
      state.isOther = false;
      if (customInputEl) customInputEl.value = '';
      state.amount = parseAmount(value);
      activateChipElement(chip);
    }
    updateSubmitLabel();
    clearError();
  }

  function activateChipElement(chip) {
    var chips = chipsContainer.querySelectorAll('[data-donate-amount]');
    chips.forEach(function (c) {
      c.classList.remove('is-active');
      c.setAttribute('aria-checked', 'false');
    });
    chip.classList.add('is-active');
    chip.setAttribute('aria-checked', 'true');
  }

  function setActiveChipByValue(value) {
    if (!chipsContainer) return;
    state.amount = parseAmount(value);
    state.isOther = false;
    if (customInputEl) customInputEl.value = '';
    var match = chipsContainer.querySelector('[data-donate-amount="' + cssEscape(String(value)) + '"]');
    if (match) {
      activateChipElement(match);
    } else {
      var first = chipsContainer.querySelector('[data-donate-amount]:not([data-donate-amount="other"])');
      if (first) {
        activateChipElement(first);
        state.amount = parseAmount(first.getAttribute('data-donate-amount'));
      }
    }
  }

  /* ── currency method (Monobank ₴ / card zł) ─────────────────────────── */

  // Locale-prefixed root ("/", "/pl/", …) so cart calls stay on the same locale.
  function cartRoot() {
    var routes = (window.Shopify || {}).routes || {};
    return routes.root || '/';
  }

  function activeCurrency() {
    return state.method === 'pln' ? pln.currency : defaults.currency;
  }

  function amountsForMethod() {
    return state.method === 'pln'
      ? pln.amounts
      : (defaults.amountsList && defaults.amountsList.length ? defaults.amountsList : null);
  }

  // The zloty chips replace the hryvnia ones in place, so the chip markup is
  // rebuilt rather than duplicated — two hidden sets would drift apart and
  // double up the radiogroup for screen readers.
  function renderChips() {
    if (!chipsContainer) return;
    var list = amountsForMethod();
    if (!list) return;

    var cur = activeCurrency();
    var other = chipsContainer.querySelector('[data-donate-amount="other"]');
    chipsContainer.querySelectorAll('[data-donate-amount]:not([data-donate-amount="other"])')
      .forEach(function (el) { el.remove(); });

    list.slice(0, 6).forEach(function (amount) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'modal__chip';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('data-donate-amount', amount);
      btn.textContent = state.method === 'pln' ? amount + ' ' + cur : cur + amount;
      chipsContainer.insertBefore(btn, other || null);
    });

    var curEl = chipsContainer.querySelector('[data-donate-chip-cur]');
    if (curEl) curEl.textContent = cur;
    if (customInputEl) {
      customInputEl.value = '';
      customInputEl.min = state.method === 'pln' ? String(pln.min) : '1';
      customInputEl.step = '1';
    }

  }

  function setMethod(name) {
    if (name !== 'pln' && name !== 'uah') return;
    if (name === 'pln' && !pln.variant) return;
    state.method = name;

    modalEl.querySelectorAll('[data-donate-method]').forEach(function (btn) {
      var active = btn.getAttribute('data-donate-method') === name;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-checked', active ? 'true' : 'false');
    });

    renderChips();
    setActiveChipByValue(name === 'pln' ? pln.defaultAmount : defaults.defaultAmount);
    updateSubmitLabel();
    clearError();
  }

  // Whole zloty only: the donation is a 1 zł line item multiplied by quantity,
  // so a fractional amount has no representation in the cart.
  function clampCustomInput() {
    if (!customInputEl || state.method !== 'pln') return;
    var digits = String(customInputEl.value || '').replace(/[^\d]/g, '');
    if (digits !== customInputEl.value) customInputEl.value = digits;
  }

  /* ── switchTab with slide direction + animated panel height ─────────── */
  function switchTab(name, skipAnimation) {
    var fromIdx = TAB_ORDER[state.currentTab] || 0;
    var toIdx = TAB_ORDER[name] || 0;
    var slideFrom = toIdx > fromIdx ? 'right' : 'left';
    state.currentTab = name;

    var tabs = modalEl.querySelectorAll('[data-donate-tab]');
    var panels = modalEl.querySelectorAll('[data-donate-panel]');

    var startHeight = panelsAreaEl && !skipAnimation ? panelsAreaEl.offsetHeight : 0;

    var tabTitle = '';
    tabs.forEach(function (t) {
      var active = t.getAttribute('data-donate-tab') === name;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
      if (active) tabTitle = t.getAttribute('data-donate-tab-title') || '';
    });

    // «Підтримка ЗСУ» above the ambassadorship is what made people think the
    // monthly payment went to the army; that tab carries its own heading.
    if (titleEl) titleEl.textContent = tabTitle || state.titleOpen || state.titleDefault;
    // The icon follows too: a heart for the army, the star for Galas's own ambassadors.
    modalEl.querySelectorAll('[data-modal-icon]').forEach(function (el) {
      el.hidden = el.getAttribute('data-modal-icon') !== (tabTitle ? 'alt' : 'main');
    });

    panels.forEach(function (p) {
      var isActive = p.getAttribute('data-donate-panel') === name;
      var wasActive = p.classList.contains('is-active');

      if (isActive && !wasActive && !skipAnimation) {
        p.classList.remove('slide-from-left', 'slide-from-right');
        void p.offsetWidth; // reflow to restart animation
        p.classList.add('slide-from-' + slideFrom);
      }

      p.classList.toggle('is-active', isActive);
      p.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    if (name === 'subscription') {
      initSubAmounts();
      updateSubCta();
    }

    if (panelsAreaEl && !skipAnimation) {
      animatePanelsHeight(startHeight);
    }
  }

  function animatePanelsHeight(startHeight) {
    // Inactive panels are absolutely positioned, so the area's natural height
    // is the active panel's height; animate between the two measurements.
    panelsAreaEl.style.height = '';
    var endHeight = panelsAreaEl.offsetHeight;
    if (endHeight === startHeight) return;

    panelsAreaEl.style.height = startHeight + 'px';
    void panelsAreaEl.offsetHeight; // reflow so the transition has a start value
    panelsAreaEl.classList.add('is-resizing');
    panelsAreaEl.style.height = endHeight + 'px';

    var done = function () {
      panelsAreaEl.classList.remove('is-resizing');
      panelsAreaEl.style.height = '';
      panelsAreaEl.removeEventListener('transitionend', done);
    };
    panelsAreaEl.addEventListener('transitionend', done);
    setTimeout(done, 400);
  }

  /* ── Subscription amount chips ───────────────────────────────────────── */
  function initSubAmounts() {
    if (!subChipsEl) return;
    state.subIsOther = false;
    if (subCustomInputEl) subCustomInputEl.value = '';
    var activeChip = subChipsEl.querySelector('.is-active[data-donate-sub-amount]');
    var defaultVal = activeChip ? activeChip.getAttribute('data-donate-sub-amount') : '20';
    state.subAmount = parseAmount(defaultVal !== 'other' ? defaultVal : '20');
    var match = subChipsEl.querySelector('[data-donate-sub-amount="' + cssEscape(String(defaultVal)) + '"]');
    var chips = subChipsEl.querySelectorAll('[data-donate-sub-amount]');
    chips.forEach(function (c) {
      c.classList.remove('is-active');
      c.setAttribute('aria-checked', 'false');
    });
    if (match) {
      match.classList.add('is-active');
      match.setAttribute('aria-checked', 'true');
    } else {
      var first = subChipsEl.querySelector('[data-donate-sub-amount]:not([data-donate-sub-amount="other"])');
      if (first) {
        first.classList.add('is-active');
        first.setAttribute('aria-checked', 'true');
        state.subAmount = parseAmount(first.getAttribute('data-donate-sub-amount'));
      }
    }
  }

  function activateSubChip(chip) {
    if (!subChipsEl) return;
    var chips = subChipsEl.querySelectorAll('[data-donate-sub-amount]');
    chips.forEach(function (c) {
      c.classList.remove('is-active');
      c.setAttribute('aria-checked', 'false');
    });
    chip.classList.add('is-active');
    chip.setAttribute('aria-checked', 'true');
  }

  function selectSubChip(chip) {
    var value = chip.getAttribute('data-donate-sub-amount');
    if (value === 'other') {
      state.subIsOther = true;
      state.subAmount = parseAmount(subCustomInputEl ? subCustomInputEl.value : '');
      activateSubChip(chip);
      if (subCustomInputEl) subCustomInputEl.focus({ preventScroll: true });
    } else {
      state.subIsOther = false;
      if (subCustomInputEl) subCustomInputEl.value = '';
      state.subAmount = parseAmount(value);
      activateSubChip(chip);
    }
    updateSubCta();
    clearSubError();
  }

  /* ── URL building ────────────────────────────────────────────────────── */
  /*
    Returns { variant, plan } or null when either id is missing.

    This used to be a cart permalink, /cart/{variant}:1?selling_plan={plan}.
    Permalinks ignore `selling_plan`: checkout sold the variant once, with no
    recurring line and BLIK on offer, so no "subscription" ever renewed. The
    plan only sticks when the line is added through the cart API.
  */
  function buildSub(freq, amount) {
    var planId = subPlans[freq] || '';
    var variantId = subVariants[String(amount)] || '';
    if (!planId || !variantId) return null;
    return { variant: variantId, plan: planId };
  }

  function lineProperties(telegram) {
    var props = { _ambassador: '1' };
    if (telegram) props.Telegram = telegram;
    return props;
  }

  function addSubAndCheckout(sub) {
    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      // `_ambassador` is how the orders-paid webhook tells a subscription from a one-time gift.
      body: JSON.stringify({ items: [{ id: Number(sub.variant), quantity: 1, selling_plan: Number(sub.plan), properties: lineProperties(sub.telegram) }] })
    }).then(function (res) {
      if (!res.ok) throw new Error('cart/add ' + res.status);
      window.location.href = cartRoot() + 'checkout';
    });
  }

  /* ── CTA labels ──────────────────────────────────────────────────────── */
  function updateSubmitLabel() {
    if (!submitLabelEl) return;
    var labelTemplate = submitLabelEl.getAttribute('data-template');
    if (!labelTemplate) {
      var raw = submitLabelEl.textContent.trim();
      var dashIdx = raw.indexOf('—');
      labelTemplate = (dashIdx > -1 ? raw.slice(0, dashIdx).trim() : raw) + ' — {{amount}}';
      submitLabelEl.setAttribute('data-template', labelTemplate);
    }
    var amount = state.amount;
    var cur = activeCurrency();
    var value = (amount && amount > 0) ? formatAmount(amount) : '0';
    // Hryvnia sits before the number, zloty after it — local convention.
    var amountText = state.method === 'pln' ? value + ' ' + cur : cur + value;
    submitLabelEl.textContent = labelTemplate.replace('{{amount}}', amountText);
  }

  // The signed-in ambassador's monthly amount, or null (snippets/ambassador-member).
  function memberAmount() {
    var raw = subChipsEl && subChipsEl.getAttribute('data-member-amount');
    var n = raw ? parseInt(raw, 10) : NaN;
    return isNaN(n) ? null : n;
  }

  function getSubCurrency() {
    return subChipsEl ? (subChipsEl.getAttribute('data-sub-currency') || defaults.currency) : defaults.currency;
  }

  function updateSubCta() {
    var labelEl = modalEl.querySelector('[data-donate-subscribe-label]');
    if (!labelEl) return;

    var freqInput = modalEl.querySelector('[data-donate-freq-input]:checked');
    var suffix = freqInput ? (freqInput.getAttribute('data-freq-suffix') || '') : '';
    var amount = state.subAmount;
    var subCur = getSubCurrency();
    // Zloty after the number, as on the one-time tab.
    var amountText = (amount && amount > 0) ? formatAmount(amount) + ' ' + subCur : '';
    var base = t('donate_modal.sub_cta', 'Підписатися');

    // An ambassador already pays: the button names the change, not a new subscription.
    var mine = memberAmount();
    if (mine && amount) {
      labelEl.textContent = amount === mine
        ? t('ambassador.current_tier', 'Ваш поточний рівень')
        : t(amount > mine ? 'ambassador.upgrade_to' : 'ambassador.change_to', 'TIER').replace('TIER', String(amount));
      return;
    }

    if (amountText) {
      labelEl.textContent = base + ' — ' + amountText + suffix;
    } else {
      labelEl.textContent = base;
    }
  }

  function formatAmount(value) {
    try {
      return new Intl.NumberFormat('uk', { maximumFractionDigits: 0 }).format(value);
    } catch (_) {
      return String(Math.round(value));
    }
  }

  function parseAmount(raw) {
    if (raw == null) return null;
    var cleaned = String(raw).replace(/[^0-9.,]/g, '').replace(',', '.');
    var num = parseFloat(cleaned);
    if (isNaN(num) || num <= 0) return null;
    return Math.round(num);
  }

  /* Mirror the donation into Google Sheets (separate "Donate" sheet). */
  function sendDonateToSheet(fields) {
    if (!sheets.endpoint || !sheets.token) return;
    var payload = {
      token: sheets.token,
      form: 'donate',
      type: fields.type || '',
      amount: (fields.amount && fields.amount > 0) ? fields.amount : '',
      currency: fields.currency || '',
      frequency: fields.frequency || '',
      name: fields.name || '',
      email: fields.email || '',
      newsletter: fields.newsletter ? 'yes' : 'no',
      page: window.location.href
    };
    try {
      fetch(sheets.endpoint, {
        method: 'POST',
        mode: 'no-cors',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(payload)
      });
    } catch (_) { /* never block the donate flow */ }
  }

  /* ── Submission ──────────────────────────────────────────────────────── */
  function onSubmit(event) {
    event.preventDefault();
    clearError();

    var amount = state.amount;
    if (!amount || amount <= 0) {
      showError(t('donate_modal_js.error_amount', 'Будь ласка, оберіть або введіть суму'));
      if (state.isOther && customInputEl) customInputEl.focus({ preventScroll: true });
      return;
    }

    var payingPln = state.method === 'pln' && pln.variant;

    if (payingPln) {
      if (amount % 1 !== 0) {
        showError(t('donate_modal_js.error_whole', 'Сума в злотих має бути цілим числом'));
        return;
      }
      if (amount < pln.min) {
        showError(
          t('donate_modal_js.error_min', 'Мінімальна сума — ') + pln.min + ' ' + pln.currency
        );
        return;
      }
    }

    var jarUrl = (state.jarUrl || defaults.jarUrl || '').trim();
    if (!payingPln && !jarUrl) {
      showError(t('donate_modal_js.error_no_jar', 'Посилання банки наразі недоступне. Спробуйте пізніше або напишіть нам.'));
      return;
    }

    // Logged-in customers are known; guests use the optional fields
    var customer = window.__galas && window.__galas.customer;
    var name, email;
    if (customer) {
      name = ((customer.first_name || '') + ' ' + (customer.last_name || '')).trim();
      email = customer.email || '';
    } else {
      name = nameInputEl ? nameInputEl.value.trim() : '';
      email = emailInputEl ? emailInputEl.value.trim() : '';

      if (email && !isValidEmail(email)) {
        showError(t('donate_modal_js.error_email', 'Введіть коректний email або залиште поле порожнім'));
        if (emailInputEl) emailInputEl.focus({ preventScroll: true });
        return;
      }
      saveDonor(name, email);
    }

    var nlCheck = modalEl.querySelector('[data-donate-newsletter]');
    var wantsNewsletter = nlCheck ? nlCheck.checked : false;

    submitEl.disabled = true;

    sendDonateToSheet({
      type: 'one-time',
      amount: amount,
      currency: payingPln ? pln.currency : defaults.currency,
      method: state.method,
      name: name,
      email: email,
      newsletter: wantsNewsletter
    });

    // Zloty: a 1 zł line item with quantity = amount, straight to checkout.
    // Hryvnia: the Monobank jar, as before.
    var finish;
    if (payingPln) {
      finish = function () {
        fetch(cartRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: pln.variant,
            quantity: amount,
            properties: (function () {
              var props = {};
              props[t('donate_modal.prop_donation', 'Донат')] = amount + ' ' + pln.currency;
              return props;
            })()
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart/add ' + res.status);
            window.location.href = cartRoot() + 'checkout';
          })
          .catch(function () {
            submitEl.disabled = false;
            showError(
              t('donate_modal_js.error_cart', 'Не вдалося створити донат. Спробуйте ще раз.')
            );
          });
      };
    } else {
      var redirect = buildDonateUrl(jarUrl, amount, name);
      finish = function () { window.location.href = redirect; };
    }

    // Guests with an email get a customer profile under the hood;
    // marketing consent only when the newsletter checkbox is ticked.
    // For logged-in customers we only need to flip consent when requested.
    if (email && (!customer || wantsNewsletter)) {
      upsertCustomer(email, name, wantsNewsletter).then(finish, finish);
    } else {
      finish();
    }
  }

  function onSubscribeClick(event) {
    event.preventDefault();
    clearSubError();

    var mine = memberAmount();
    if (mine) {
      var cabinet = subChipsEl.getAttribute('data-cabinet-url') || '/pages/profile';
      var amount = state.subAmount;
      window.location.href = amount && amount !== mine
        ? cabinet + (cabinet.indexOf('?') === -1 ? '?' : '&') + 'manage=level&tier=' + amount
        : cabinet;
      return;
    }

    var freqInput = modalEl.querySelector('[data-donate-freq-input]:checked');
    if (!freqInput) {
      showSubError(t('donate_modal_js.error_tier', 'Оберіть частоту підписки'));
      return;
    }

    var freq = freqInput.value;

    if (state.subIsOther && (!state.subAmount || state.subAmount <= 0)) {
      showSubError(t('donate_modal_js.error_amount', 'Будь ласка, введіть суму'));
      if (subCustomInputEl) subCustomInputEl.focus({ preventScroll: true });
      return;
    }

    var amount = state.subAmount;
    if (!amount || amount <= 0) {
      showSubError(t('donate_modal_js.error_amount', 'Будь ласка, оберіть суму'));
      return;
    }

    var sub = buildSub(freq, amount);
    if (!sub) {
      showSubError(t('donate_modal_js.error_generic', 'Підписка ще не налаштована. Зверніться до адміністратора.'));
      return;
    }

    // The ambassador modal takes it from here: name, email, Telegram, and a cart
    // with exactly one tier (snippets/ambassador-modal.liquid).
    if (window.GalasAmbassador) {
      var tierIndex = { '25': 1, '50': 2, '100': 3 }[String(amount)];
      close();
      window.GalasAmbassador.open({ tier: tierIndex });
      return;
    }

    var btn = event.currentTarget;
    btn.disabled = true;

    var nlCheck = modalEl.querySelector('[data-donate-sub-newsletter]');
    var wantsNewsletter = nlCheck ? nlCheck.checked : false;
    var customer = window.__galas && window.__galas.customer;

    sendDonateToSheet({
      type: 'subscription',
      amount: amount,
      currency: getSubCurrency(),
      frequency: freq,
      name: customer ? ((customer.first_name || '') + ' ' + (customer.last_name || '')).trim() : '',
      email: customer ? (customer.email || '') : '',
      newsletter: wantsNewsletter
    });

    var go = function () {
      addSubAndCheckout(sub).catch(function () {
        btn.disabled = false;
        showSubError(t('donate_modal_js.error_generic', 'Не вдалося. Спробуйте ще раз.'));
      });
    };

    if (wantsNewsletter && customer && customer.email) {
      upsertCustomer(customer.email, customer.first_name || '', true).then(go, go);
    } else {
      go();
    }
  }

  /* ── Helpers ─────────────────────────────────────────────────────────── */
  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function loadDonor() {
    try {
      return JSON.parse(window.localStorage.getItem(DONOR_STORAGE_KEY)) || {};
    } catch (_) {
      return {};
    }
  }

  function saveDonor(name, email) {
    if (!name && !email) return;
    try {
      window.localStorage.setItem(DONOR_STORAGE_KEY, JSON.stringify({ name: name, email: email }));
    } catch (_) {
      /* storage unavailable (private mode etc.) — non-critical */
    }
  }

  /* Creates or updates a Shopify customer profile (Admin → Customers).
     Marketing consent is granted only when acceptsMarketing is true. */
  function upsertCustomer(email, name, acceptsMarketing) {
    return new Promise(function (resolve, reject) {
      var params = new URLSearchParams();
      params.set('form_type', 'customer');
      params.set('utf8', '\u2713');
      params.set('contact[tags]', acceptsMarketing ? 'donor,newsletter' : 'donor');
      params.set('contact[email]', email);
      // Never send "false": it could revoke consent for an already-subscribed email
      if (acceptsMarketing) params.set('contact[accepts_marketing]', 'true');
      if (name) {
        var parts = name.split(/\s+/);
        params.set('contact[first_name]', parts[0]);
        if (parts.length > 1) params.set('contact[last_name]', parts.slice(1).join(' '));
      }
      fetch('/contact#contact_form', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'text/html'
        },
        body: params.toString()
      }).then(function (res) {
        if (res.ok || res.status === 0 || res.type === 'opaqueredirect') {
          resolve(res);
        } else {
          reject(res);
        }
      }, reject);
    });
  }

  function buildDonateUrl(base, amount, name) {
    try {
      var url = new URL(base, window.location.origin);
      url.searchParams.set('a', String(amount));
      if (name) url.searchParams.set('t', name);
      return url.toString();
    } catch (_) {
      var sep = base.indexOf('?') === -1 ? '?' : '&';
      var qs = 'a=' + encodeURIComponent(String(amount));
      if (name) qs += '&t=' + encodeURIComponent(name);
      return base + sep + qs;
    }
  }

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function clearError() {
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.hidden = true;
  }

  function showSubError(message) {
    var el = modalEl.querySelector('[data-donate-sub-error]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function clearSubError() {
    var el = modalEl.querySelector('[data-donate-sub-error]');
    if (!el) return;
    el.textContent = '';
    el.hidden = true;
  }

  function parseDuration(value) {
    if (!value) return 0;
    var parts = value.split(',');
    var max = 0;
    parts.forEach(function (raw) {
      var v = raw.trim();
      var ms = v.endsWith('ms') ? parseFloat(v) : parseFloat(v) * 1000;
      if (!isNaN(ms) && ms > max) max = ms;
    });
    return max;
  }

  function t(key, fallback) {
    var dict = window.DonateModalI18n || {};
    return dict[key] || fallback;
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return String(value).replace(/[^a-zA-Z0-9_-]/g, function (c) {
      return '\\' + c;
    });
  }

  window.DonateModal = {
    open: function (tab) { open(null, tab || 'one-time'); },
    close: close
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
